import { ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { UserResponse } from '@interfaces/user';
import { Select, Store } from '@ngxs/store';
import { CrossSellBannerComponent } from '@shared/components/cross-sell-banner/cross-sell-banner.component';
import { RemarksComponent } from '@shared/components/modal/remarks/remarks.component';
import { RemarksAddeddComponent } from '@shared/components/modal/remarks-addedd/remarks-addedd.component';
import { RequestCancellationComponent } from '@shared/components/modal/request-cancellation/request-cancellation.component';
import { SharedModule } from '@shared/shared.module';
import { CALCULATE_PREMIUM, CALCULATE_PREMIUM_NCD, CANCEL_COVER_NOTE, CANCEL_QUOTATION, CANCEL_REPLACE, COMPLETE_PAGE_RESET_STATE, CONTINUE_ISSUANCE, COPY_CNGE_INFO, COPY_CNGE_INFO_VIEW_QUOTATION, DOWNLOAD_PDF, GET_CROSS_SELL_LIST, GET_EMAIL_CUTOFF, GET_QUOTATION_DETAIL, GET_REDIRECT_PAGE, GET_SWITCH_SITE, IS_CANCEL_AT_COMPLETE, IS_CANCEL_REPLACE_COVER_NOTE, REQUEST_CANCELLATION, RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ, SAVE_REFERRAL_REMARKS, SEARCH_ORIXCompanyInfo, SEND_TO_JPJ, SET_ACTION, SET_CURRENT_STEP, SET_JPJ_STATUS_SENT, STORE_COMPLETE_DATA, STORE_EXTRA_COVER_SUMMARY } from '@store/sat-motor/sat-motor.action';
import { SatMotorState } from '@store/sat-motor/sat-motor.state';
import { catchError, Observable, throwError } from 'rxjs';
import { OkMessageComponent } from '@shared/components/modal/ok-message/ok-message.component';
import { StatusMessageComponent } from '@shared/components/status-message/status-message.component';
import { CompleteInformationComponent } from '@shared/components/complete-information/complete-information.component';
import { STORE_QUERY_PARAMS } from '@store/user/user.action';
import { SummaryPopupComponent } from 'src/app/popup/summary-popup/summary-popup.component';
import { ClauseMessageComponent } from '@shared/components/modal/clause-message/clause-message.component';
import { EmailDocumentComponent } from '@shared/components/modal/email-document/email-document.component';
import { UploadDocumentComponent } from '@shared/components/upload-document/upload-document.component';
import { ConfirmationModalComponent } from '@shared/components/modal/confirmation-modal/confirmation-modal.component';
import { MessagePromptModalComponent } from '@shared/components/modal/message-prompt-modal/message-prompt-modal.component';
import { AccessConfig, ButtonAccessConfig } from '@shared/helpers/sat-menu-access-config';
import { MenuAccessService } from '@shared/services/sat-menu-access/menu-access.service';
import { ErrorModalComponent } from '@shared/components/modal/error-modal/error-modal.component';
import { RESET_ERROR_MESSAGE, SET_ERROR_FLAG, SET_ERROR_MESSAGE } from '@store/exception/error.action';
import { ErrorState, ErrorModel } from '@store/exception/error.state';
import { ACTIONS } from '@shared/enums/index.enum';

@Component({
  selector: 'app-complete',
  standalone: true,
  imports: [
    SharedModule,
    RemarksComponent,
    CrossSellBannerComponent,
    StatusMessageComponent,
    CompleteInformationComponent
  ],
  templateUrl: './complete.component.html',
  styleUrl: './complete.component.scss'
})
export class CompleteComponent implements OnInit{
  @Select(SatMotorState.motorStep4Summary) step4$: Observable<any>;
  @Select(SatMotorState.motorActionType) actionType$;
  @Select(SatMotorState.rtpStep2Summary) rtpSummary$: Observable<any>;

  @Select(ErrorState.error) error$: Observable<any>;

  isIssuance: boolean = false; 
  isEndorsement: boolean = false; 
  isEnquiry: boolean = false;
  isRTP: boolean = false;

  templateDialogRef?: NxModalRef<any>;
  componentDialogRef?: NxModalRef<CompleteComponent>;
  componentDialogRef2?: NxModalRef<SummaryPopupComponent>;


  componentDialogRef1?: NxModalRef<EmailDocumentComponent>;

  referralRemarksModal?: NxModalRef<RemarksComponent>;
  requestCancellationModal?: NxModalRef<RequestCancellationComponent>;
  remarksAddedModal?: NxModalRef<RemarksAddeddComponent>;
  clauseMsgModal?: NxModalRef<ClauseMessageComponent>;
  confirmMessageModal?: NxModalRef<ConfirmationModalComponent>;
  dialogRef?: NxModalRef<any>;

  agentInfo: any;
  userInfo: UserResponse;
  declarationInfo: any;
  customerPartnerInfo: any;
  crossSellList: any = [];
  marketingConsent: any;
  data: any;
  okMessageModal?: NxModalRef<OkMessageComponent>;
  queryParam: any;
  cnoteType: any;
  motorPC: any;
  lovproductConfig: any;
  productAccessListData: any;
  lovPC: string;
  lovGeo: any;
  emailCheck : any;
  edocConsentInd: boolean = false;
  eInvoiceConsentInd : boolean;
  isUpdatePayment: any;
  isCCentric: boolean = false
  issueOnQuotation: boolean = false;
  agentData: any;
  isSingleAgent: boolean = false;
  dataORIXLeasingLov: any;
  blocked: boolean = false;

  constructor(
    private store: Store,
    private readonly dialogService: NxDialogService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private accessService: MenuAccessService
  ) {}

  ngOnInit() {
    window.scroll({ top: 0, left: 0, behavior: 'instant' });

    const errorCode = this.store.selectSnapshot<any>((state) => state.ErrorState?.detail?.code);
    if (errorCode) {
      this.blocked = errorCode !== 200;
    }
    
    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);
    this.queryParam = this.store.selectSnapshot<any>((state) => state.UserState.queryParams);
    this.cnoteType = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step1?.issuance?.issuance?.cnoteType);
    this.edocConsentInd = this.store.selectSnapshot<boolean>(state => state.SatMotorState.motor.step1?.issuance?.pdpa?.consentDetails?.edocConsentInd);
    this.eInvoiceConsentInd = this.store.selectSnapshot<boolean>(state => state.SatMotorState.motor.step1?.issuance?.pdpa?.consentDetails?.einvoiceConsentInd);
    this.isUpdatePayment = this.store.selectSnapshot<any>(state => state.SatMotorState.isUpdatePayment);
    this.isCCentric = this.store.selectSnapshot<any>((state) => state.SatMotorState.opportunityId);
    this.issueOnQuotation = this.userInfo?.issueOnQuotation;
    this.agentData = this.store.selectSnapshot(SatMotorState.motorAgentDetail);
    this.isSingleAgent = this.store.selectSnapshot<any>((state) => state.SatMotorState.isSingleAgent);
    this.dataORIXLeasingLov = this.store.selectSnapshot<any>((state) => state.SatMotorState.lov?.searchORIXCompany);

    this.actionType$.subscribe((state) => {
      if (state) {
        this.isIssuance = state.isIssuance;
        this.isEndorsement = state.isEndorsement;
        this.isEnquiry = state.isEnquiry;
        this.isRTP = state.isRTP;
      }
    });

    this.error$.subscribe((err) => {
      console.log(err);
      if (err?.code)
        this.blocked = (err?.code !== 200);
    });

    this.setStep();
    let completeData;

    if(this.isIssuance) {
      completeData = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step5?.cngeNote);
    }else if(this.isRTP) {
      completeData = this.store.selectSnapshot<any>(state => state.SatMotorState.rtp.step3?.cngeNote);
    }

    if(!completeData) {
      if (this.isIssuance) {
        this.loadIssuanceData();
      }

      if (this.isRTP) {
        this.loadRTPData();
      }

      if (this.isEndorsement) {
        this.loadEndorsementData();
      }
    }else {
      if(this.isIssuance) {
        let generateQuotationData = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.data);
        let sendToJPJData = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ?.data);
        let updatePaymentData = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.updatePayment?.data);

        if (updatePaymentData) {
          if(completeData.contractId !== updatePaymentData.contractId) {
            this.data = updatePaymentData;
            this.storeCompleteData();
          }else {
            this.data = completeData;
          }
        
        } else if (sendToJPJData) {
          if(completeData.contractId !== sendToJPJData.contractId) {
            this.data = sendToJPJData;
            this.storeCompleteData();
          }else {
            this.data = completeData;
          }
          
        } else if (generateQuotationData) {
          if (completeData.contractId !== generateQuotationData.contractId) {
            this.data = generateQuotationData;
            this.storeCompleteData();
          } else {
            this.data = completeData;
          }
        }
      }else {
        this.data = completeData;
      }
      
    }

    if (!this.dataORIXLeasingLov || this.dataORIXLeasingLov === ""){
      this.store.dispatch(new SEARCH_ORIXCompanyInfo({ agentCode: this.agentInfo.agentCode, 
        loanCompany: this.data?.riskList[0].vehicleLoanCompany, loanType: this.data?.riskList[0].vehicleLoanType, 
        vehType: this.data?.productCode, eInvoiceInd: this.data?.einvoiceConsentInd})).subscribe((state) => {        
          if (state.SatMotorState.lov.searchORIXCompany){
            this.dataORIXLeasingLov = state.SatMotorState?.lov?.searchORIXCompany;
          }
        });
    }
  }

  loadEndorsementData() {
    //endt data
  }

  loadRTPData() {
    this.rtpSummary$.subscribe(summary => {
      let sendToJPJData = summary.sendToJPJ?.data?.cngeNoteDto;

      if (sendToJPJData) {
        this.data = sendToJPJData;
        this.agentInfo = this.data.mkagAgent;
        this.customerPartnerInfo = this.data.clientPartner;
        this.storeCompleteData();
      }
    });
  }

  loadIssuanceData() {
    this.step4$.subscribe(step4 => {
      let generateQuotationData = step4?.generateQuotation?.data;
      let sendToJPJData = step4?.sendToJPJ?.data;
      let updatePaymentData = step4?.updatePayment?.data;

      if(updatePaymentData) {
        this.data = updatePaymentData;
        this.storeCompleteData();
      }else if (sendToJPJData && step4?.sendToJPJ?.success) {
        this.data = sendToJPJData;
        this.storeCompleteData();
      } else if (generateQuotationData) {
        this.data = generateQuotationData;
        this.storeCompleteData();
      }

    });
    
    this.agentInfo = this.data.mkagAgent;
    this.customerPartnerInfo = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step2);

    // let getCrossSellListPayload = {
    //   "agentCode": this.agentInfo.agentCode,
    //   "partnerId": this.customerPartnerInfo.partnerId,
    //   "idType": this.customerPartnerInfo.idType1,
    //   "idValue": this.customerPartnerInfo.idValue1
    // };
    // this.store.dispatch(new GET_CROSS_SELL_LIST(getCrossSellListPayload)).subscribe(state => {
    //   if (state.SatMotorState.data.step5.crossSellList) {
    //     this.crossSellList = state.SatMotorState.data.step5.crossSellList;
    //     this.marketingConsent = state.SatMotorState.data.step5.marketingConsent;
    //     console.log("cross sell list: ", this.crossSellList);
    //   }
    // });
  }

  // openFromTemplate(): void {
  //     this.dialogService.open(this.reasoncancellationRef, {
  //         ariaLabel: 'A simple modal',
  //         disableClose: true,
  //     });
  // }

  setStep() {
    let step;
    if (this.isRTP) {
      step = 3;
    } else if (this.isEndorsement) {
      step = 4;
    } else {
      if ((this.agentData?.bancaAgent || this.agentData?.sundriesAgent)) {
        step = 6;
      } else {
        step = 5;
      }
    }
    this.store.dispatch(new SET_CURRENT_STEP(step));
  }

  openPopupReferralRemarks() {
    this.referralRemarksModal = this.dialogService.open(RemarksComponent, {
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      data: {
        title: "Please add remarks",
        primaryButtonLabel: "SUBMIT"
      }
    });

    this.referralRemarksModal.afterClosed().subscribe(result => {
      if(result) {
        const data = {
          remark: result.remarks,
          operator: this.userInfo.userId, // uncomment after SAVE_REFERRAL_REMARKS BE complete
          contractId: this.data.contractId // uncomment after SAVE_REFERRAL_REMARKS BE complete
        };
        this.store.dispatch(new SAVE_REFERRAL_REMARKS(data)).subscribe(state => {
          this.remarksAddedModal = this.dialogService.open(RemarksAddeddComponent, {
            showCloseIcon: false,
            disableClose: true,
            width: '550px',
            maxWidth: '550px'
          });
        });
      }
    });
  }

  options = [
    "BMW",
    "Audi",
    "VW",
    "Mercedes",
    "Porsche",
    "Tesla",
    "Lada",
    "Opel",
    "Fiat",
    "Ford",
    "Kia",
    "Toyota",
    "Ferrari",
  ];

  closeTemplateDialog() {
    this.templateDialogRef?.close();
  }

  prepareCancellationData() {
    this.store.dispatch(new GET_QUOTATION_DETAIL(this.data.contractId, "SUMMARY")).subscribe((state) => {
      let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.viewQuotation);
      
      if (cngeNote) {
        console.log("Current JPJ status: "+cngeNote.jpjStatus);
        this.data = cngeNote;
        this.openRequestCancellationPopUp();
      }
    });
  }

  openRequestCancellationPopUp() {

    if (this.data.cnoteNo && this.data.cnoteStatus === "PRINTED" && !this.data.jpjStatus) {
      this.okMessageModal = this.dialogService.open(OkMessageComponent, {
        width: "410px",
        maxWidth: "410px",
        showCloseIcon: false,
        disableClose: true,
        autoFocus: false,
        data: {
          message: "JPJ Status Pending, please try again."
        }
      });
      return;
    }

    if(this.data.cnoteNo && this.data.cnoteStatus === "PRINTED" && this.data.jpjStatus === "SENT") {
      this.okMessageModal = this.dialogService.open(OkMessageComponent, {
        width: "410px",
        maxWidth: "410px",
        showCloseIcon: false,
        disableClose: true,
        autoFocus: false,
        data: {
          message: "JPJ Status Sent, please try again."
        }
      });
      return;
    }

    let data = {
      summaryData: this.data
    }

    this.requestCancellationModal = this.dialogService.open(RequestCancellationComponent, {
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      data: data
    });

    this.requestCancellationModal.afterClosed().subscribe(result => {
      if(result) {
        let payload = {
          cancelRemarks: result.data.cancelRemarks,
          cancelReasonCode: result.data.cancellationReason,
          contractId: this.data.contractId,
          operator: this.userInfo.userId
        };

        if (result.isCancelAndReplace) {
          this.store.dispatch(new CANCEL_REPLACE(payload)).subscribe((state) => {
            let cancellationRes = state.SatMotorState.data.cancellationRes;
            this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION(cancellationRes)).subscribe(state => {
              this.store.dispatch(new RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ({
                isIssuance: true
              }));
              this.store.dispatch(new IS_CANCEL_REPLACE_COVER_NOTE(this.data));
              this.calculatePremiumCancelReplace(cancellationRes, this.data);
              //this.router.navigate(['issuance/summary']);
            });
          });
          
        } else {
          if(this.isEquotation) {
            this.store.dispatch(new CANCEL_QUOTATION(payload)).subscribe(state => {
              let cancellationRes = state.SatMotorState.data.cancellationRes;
              if(cancellationRes) {
                this.data = cancellationRes;
                this.storeCompleteData();
                this.store.dispatch(new IS_CANCEL_AT_COMPLETE(true));
                // this.goToViewPage();
              }
            });
          }else {
            this.store.dispatch(new CANCEL_COVER_NOTE(payload)).subscribe(state => {
              let cancellationRes = state.SatMotorState.data.cancellationRes;
              if(cancellationRes) {
                this.data = cancellationRes;
                this.storeCompleteData();
                this.store.dispatch(new IS_CANCEL_AT_COMPLETE(true));
              }
            });
          }
          // this.store.dispatch(new REQUEST_CANCELLATION(cancellationPayload));
        }
      }
    });
  }

  backToSummaryListing() {

    this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe((state) => {
      let switchSiteUrl = state.SatMotorState.data.switchSiteUrl;
      console.log("SwitchSiteUrl Url : " + switchSiteUrl);
      window.location.href = switchSiteUrl;
    });

  }

  goToViewPage() {
    this.queryParam = {
      ...this.queryParam,
      contractId: this.data.contractId,
      action: 'COMPLETE'
    }
    this.store.dispatch(new STORE_QUERY_PARAMS(this.queryParam)).subscribe(() => {
      this.store.dispatch(new COMPLETE_PAGE_RESET_STATE()).subscribe(() => {
        this.store.dispatch(new SET_ACTION(ACTIONS.VIEW)).subscribe(() => {
          this.router.navigate(["/view-quotation"]);
        });
      });
    });
  }

  onContinueIssuance() {
     //AGIC-44964,44965,43876
    this.store.dispatch(new CONTINUE_ISSUANCE()).subscribe(state => {
      this.router.navigate(['issuance/declaration-issuance-info']);
    }); 
  }

  get isCoverNote() {
    if(this.data?.cnoteNo) {
      return true;
    }else {
      return false;
    }
  }

  get isEquotation() {
    if(!this.data?.cnoteNo && this.data?.proposalNo && !this.data?.draftInd) {
      return true;
    }else {
      return false;
    }
  }

  get isCoverQuotation(){
    if(this.data?.cnoteNo && this.data?.proposalNo) {
          return true;
        }else {
          return false;
        }
  }

  downloadPDF(contractId: string, type: string, autoDownload: boolean) {
    const payload: any = {
      operator: this.userInfo.userId,
      contractId: contractId || this.data.contractId,
      type: type,
    };
  
    let vehicleNo = this.data.riskList[0].vehicleNo;
    let cnoteType = this.data.cnoteType;

    if (type === 'covernote' && !autoDownload && !(cnoteType === 'NWNN' && vehicleNo === 'NA')) {
      this.clauseMsgModal = this.dialogService.open(ClauseMessageComponent, {
        disableClose: true,
        width: '450px',
        maxWidth: '450px',
      });
      this.clauseMsgModal.afterClosed().subscribe(result => {
        payload.printClauseInd = (result === 'Y');
        this.store.dispatch(new DOWNLOAD_PDF(payload));
      });
    } else {
      this.store.dispatch(new DOWNLOAD_PDF(payload)).subscribe();
    }
  }

  checkORIXOverwiteBeforeSendJPJ(){
    if (this.data?.einvoiceConsentInd && this.data?.riskList[0].vehicleLoanType === "L"
      && this.data?.riskList[0].vehicleLoanCompany === "ORIX" && this.dataORIXLeasingLov){
      const leasingCompanyItem = this.dataORIXLeasingLov?.find(item => item.companyCode === this.data?.leasCompCode);
      const messageBuyerOverwrite = "You have overwritten Buyer information from Policy Holder to " + leasingCompanyItem?.companyDesc
      + ". Kindly confirm. Click Yes to confirm and No to amend the details";
      const messagePolHolder = "Buyer's information is policy holder. Kindly confirm. Click Yes to confirm and No to amend the details";

      this.confirmMessageModal = this.dialogService.open(ConfirmationModalComponent, {
        showCloseIcon: false, width: "550px", maxWidth: "550px",
        disableClose: true,
        data: {
          message: this.data?.buyerOverwriteInd ? messageBuyerOverwrite : messagePolHolder,
        }
      });
      this.confirmMessageModal.afterClosed().subscribe(result => {
        if (result) { 
          this.sendToJPJ();
        } else {
          return;
        }
      });
    } else {
      this.sendToJPJ();
    }
  }

  sendToJPJ() {
    let hasSendToJpj = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step4?.sendToJPJ);

    if (hasSendToJpj?.data?.cnoteNo) {
      this.okMessageModal = this.dialogService.open(OkMessageComponent, {
        disableClose: true,
        width: '400px',
        data: {
          message: "Record has been updated by someone. Please re-select the record again"
        }
      });
      return;
    }


    let address1 = this.data.clientPartner.clientPartnerAddress.clientAddress1Tmp?.trim();
    let emailValue = this.data.clientPartner.clientEmail?.trim();
    this.motorPC = this.store.selectSnapshot<any>((state)=>state.SatMotorState.motor.step1?.issuance?.issuance?.productCode);
    this.lovproductConfig = this.store.selectSnapshot<any>((state)=>state.SatMotorState.lov.productAccessConfigList);
    let custAge = this.data?.clientPartner?.clientAge;
    let cpType = this.data?.clientPartner?.idType1;


    
    for (let i = 0; i < this.lovproductConfig.length; i++) {
    this.productAccessListData = this.lovproductConfig[i];
    this.lovPC = Object.keys( this.productAccessListData)[0]; 
  
      if (this.lovPC === this.motorPC) {
       this.emailCheck = this.productAccessListData[this.lovPC].emailCheckEnableSat;
      }
    }

    if(((!address1) && (!emailValue)) && ((this.edocConsentInd) || (this.emailCheck =="true") || (this.eInvoiceConsentInd)) && (!this.isRTP) ){
      this.openPopup("addrEmailSum");
    }
    else if(((address1) && (!emailValue)) && ((this.edocConsentInd) || (this.emailCheck =="true") || (this.eInvoiceConsentInd)) && (!this.isRTP) ){
      this.openPopup("emailSum");
    }
    else if ((!address1) && ((emailValue)||(!emailValue)) && (!this.isRTP)) {
      this.openPopup("address");
    }
    else if((custAge < 16 || custAge > 99) && (!this.isRTP) &&(cpType !=="NEW_BR_NO" && cpType !=="BR_NO")){
      this.openPopup("custAge");
    }
    else {
    let summaryData = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.summary);
    let payload = {
      userId: this.userInfo.userId,
      isRTP: this.isRTP,
      proposalNo: this.data.proposalNo,
      contractId: this.data.contractId,
      cnoteDate: this.data.cnoteDate,
      issueBy: this.data.issueBy,
      issuedDate: this.data.cnoteDate,
      cnoteType: this.cnoteType,
      waiveLoadInd: summaryData.referCaseData.waiveLoadInd,
      waiveExcessInd: summaryData.referCaseData.waiveExcessInd,
      underwritingInd: summaryData.referCaseData.underwritingInd,
      agentReferId: summaryData.referralId,
      referRemarkList: null,
    };

    const referRemarkValue = summaryData.referCaseData.remarks ?? null;
    if (referRemarkValue) {
      payload = {
        ...payload,
        referRemarkList: [
          {
            referRemark: referRemarkValue,
            createdBy: this.userInfo.userId
          }
        ]
      };
    } else {
      delete payload.referRemarkList;
    }
          
    this.store.dispatch(new SET_ERROR_FLAG({ code: 999 })).subscribe(() => { this.blocked = true; });
    this.store.dispatch(new SEND_TO_JPJ(payload))
    .pipe(
      catchError(e => {
        this.store.dispatch(new SET_ERROR_MESSAGE(e));
        this.dialogService.open(ErrorModalComponent, {
          disableClose: true,
          width: "400px",  data: { e: e },
        });
        return throwError(e);
      })
    )
    .subscribe(() => {
      this.store.dispatch(new RESET_ERROR_MESSAGE()).subscribe(() => { this.blocked = false; });
      let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ ?? null);
      console.log(response);

      if (response && response.data && response.success && response.data.contractId) {
        let contractId = response?.data?.contractId;

        this.data = response.data;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        
        if(response?.data?.cnoteStatus === 'PRINTED') {
          this.downloadPDF(contractId, 'covernote', true);
        }
        
      }

      let message = (response?.message && response?.message != '') ? response?.message : (response?.errorCode && response?.errorCode != '') ? response?.errorCode : null;
      if (message) {
        if (response.messageHeader) {
          let ncdInfo = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.ncdInfo);
          if (!ncdInfo) {
            ncdInfo = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.ncdInfo);
          } 

          if (ncdInfo && ncdInfo.blockIssuanceInd) {
            this.okMessageModal = this.dialogService.open(OkMessageComponent, {
              disableClose: true,
              width: '400px',
              data: {
                message: ncdInfo.errMsg
              }
            });
          }
        } else {
          this.okMessageModal = this.dialogService.open(OkMessageComponent, {
            disableClose: true,
            width: '400px',
            data: {
              message: message
            }
          });
        }
      } else if (response.messageConfirm && response.messageHeader) {
        this.showConfirmationMessage(response, payload);
      }
    });
    }
  }

  showConfirmationMessage(response, payload) {
    this.dialogService.open(MessagePromptModalComponent, {
      ariaLabel: "A simple dialog",
      width: '400px',
      showCloseIcon: false,
      disableClose: true,
      data: { message: response.messageConfirm },
    })
    .afterClosed().subscribe(result => {
      if (result) {

        let summaryPremium = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step4?.summary?.coverageInfo?.coverage?.coveragePremium?.cngeNote);
        let coveragePremium = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step3.coverage.coveragePremium.cngeNote);
        let cngeNote = summaryPremium ? summaryPremium : coveragePremium;

        if (!cngeNote.skipErrorAndProceed) {

          let calcPremPayload = { 
            cngeNote: { 
              ...cngeNote, 
              skipErrorAndProceed: true,
              riskList: [{
                ...cngeNote.riskList[0],
                coverList: [{
                  ...cngeNote.riskList[0].coverList[0],
                  ncdPercentage: 0
                }]
              }]
            }, 
            operator: this.userInfo.userId
          };

          this.store.dispatch(new CALCULATE_PREMIUM_NCD(calcPremPayload)).subscribe(state => {
            this.router.navigate(['issuance/summary'], {
              queryParamsHandling: 'preserve',
            });
          });

        } else {
          let resendPayload = {
            ...payload,
            contractId: this.data.contractId,
            skipErrorAndProceed: true
          }
          
          this.store.dispatch(new SET_ERROR_FLAG({ code: 999 })).subscribe(() => { this.blocked = true; });
          this.store.dispatch(new SEND_TO_JPJ(resendPayload))
          .pipe(
            catchError(e => {
              this.store.dispatch(new SET_ERROR_MESSAGE(e));
              this.dialogService.open(ErrorModalComponent, {
                disableClose: true,
                width: "400px",  data: { e: e },
              });
              return throwError(e);
            })
          )
          .subscribe(() => {
            this.store.dispatch(new RESET_ERROR_MESSAGE()).subscribe(() => { this.blocked = false; });
            let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ ?? null);
            console.log(response);
  
            if (response && response.data && response.success && response.data.contractId) {
              let contractId = response?.data?.contractId;
  
              this.data = response.data;
              this.cdr.markForCheck();
              this.cdr.detectChanges();
  
              if (response?.data?.cnoteStatus === 'PRINTED') {
                this.downloadPDF(contractId, 'covernote', true);
              }
  
            }
  
            let message = (response?.message && response?.message != '') ? response?.message : (response?.errorCode && response?.errorCode != '') ? response?.errorCode : null;
            if (message) {
              if (response.messageHeader) {
                let ncdInfo = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.ncdInfo);
                if (!ncdInfo) {
                  ncdInfo = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.ncdInfo);
                } 
      
                if (ncdInfo && ncdInfo.blockIssuanceInd) {
                  this.okMessageModal = this.dialogService.open(OkMessageComponent, {
                    disableClose: true,
                    width: '400px',
                    data: {
                      message: ncdInfo.errMsg
                    }
                  });
                }
              } else {
                this.okMessageModal = this.dialogService.open(OkMessageComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    message: message
                  }
                });
              }
            } else if (response.messageConfirm && response.messageHeader) {
              this.showConfirmationMessage(response, payload);
            }
  
          });
        }
      }
    });
  }

  storeCompleteData() {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
    
    let payload = {
      isIssuance: this.isIssuance,
      isRTP: this.isRTP,
      cngeNote: this.data
    }

    this.store.dispatch(new STORE_COMPLETE_DATA(payload));
  }
  openPopup(popup_type: any) {

    this.componentDialogRef2 = this.dialogService.open(SummaryPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { popup_type: popup_type },
    });
  }

  checkQuotationStatus(popup_type) {
    if (this.data.cnoteNo) {
      this.openPopupEmailDoc(popup_type);
    } else {
      this.checkValidationCuttOff(popup_type);
    }
  }

  checkValidationCuttOff(popup_type) {
    this.store.dispatch(new GET_EMAIL_CUTOFF(this.data.contractId)).subscribe((state) => {
      let res = state.SatMotorState?.emailValidationCutOff;
      if (res?.success) {
        this.openPopupEmailDoc(popup_type);
      
      } else if (res && !res.success && res.message) {
        this.okMessageModal = this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: res.message
          }
        });
      
      } else {
        this.openPopupEmailDoc(popup_type);
      }
    });
  }

  openPopupEmailDoc(popup_type: any) {
    this.componentDialogRef1 = this.dialogService.open(EmailDocumentComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "95%",
      maxWidth: "900px",
      maxHeight: "95vh",
      data: { popup_type: popup_type },
    });
  }

  uploadDocument() {
    const productCode = this.store.selectSnapshot<any>((state)=>state.SatMotorState.motor.step1?.issuance?.issuance?.productCode);
    let contractId = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step1?.issuance?.issuance?.contractId);
    if (!contractId)
      contractId = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step3?.contractId);
    if (!contractId)
      contractId = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step4?.generateQuotation?.contractId);
    if (!contractId)
      contractId = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step5?.cngeNote?.contractId);

    let dialogConfig = {
      showCloseIcon: false,
      disableClose: true,
      width: "80%",
      maxWidth: "80vw",
      maxHeight: "95vh",
      data: {
        productCode: productCode,
        contractId: contractId
      }
    };

    this.dialogRef = this.dialogService.open(UploadDocumentComponent, dialogConfig); 
  }

  isDisableEmailButton(): boolean {
    //return this.edocConsentInd ? false : true;
    return false; //AGIC-46575: should be enable regardless e-Document is Yes/No
  }

  isShowInvoicePDFButton(): boolean {
    return this.data.cnoteStatus === 'PRINTED' && this.data.cnoteNo && this.eInvoiceConsentInd === true;
  }

  isDisableInvoicePDFButton(): boolean {
    return (this.data?.einvoiceStatus && this.data?.einvoiceStatus === 'VALID') ? this.validateAccess(AccessConfig.TAX_INVOICE) : true;
  }

  isDisableUpload() {

    if (this.blocked)
      return true;
    return false;
    
  }

  isDisableSendToJPJ() {
    if (this.blocked)
      return true;
    
    if (this.isRTP) {
      return false;
    } else {
      return this.validateAccess(AccessConfig.SEND_TO_JPJ);
    }
  }

  isDisableViewButton() {
    if (this.isRTP) {
      return false;
    } else {
      return this.validateAccess(this.isEquotation ? AccessConfig.VIEW_QUOTATION : AccessConfig.VIEW_COVER_NOTE);
    }
  }

  isDisableRequestCancel(): boolean {
    const { cnoteNo, createBy, updateBy } = this.data;
    const { userId, issueOnBehalf, issueOnEndorsement, menuAccess } = this.userInfo;

    const isCoverNote = !!cnoteNo;

    let isDisabled = this.validateAccess(isCoverNote ? AccessConfig.CANCEL_COVER_NOTE : AccessConfig.CANCEL_QUOTATION);
    if (isDisabled) {
      return true;
    }

    isDisabled = (issueOnBehalf || issueOnEndorsement) &&
      (createBy !== userId && updateBy !== userId);

    return isDisabled; //If true means disable
  }

  calculatePremiumCancelReplace(updateQuotationDetails, viewQuotationDetails) {
    if (viewQuotationDetails?.riskList?.[0]?.coverList?.[0]?.subCovPackage) {
        updateQuotationDetails = {
          ...updateQuotationDetails,
          riskList: [
            {
              ...updateQuotationDetails.riskList[0],
              coverList: [
                {
                  ...updateQuotationDetails.riskList[0].coverList[0],
                  subCovPackage: viewQuotationDetails.riskList[0].coverList[0].subCovPackage,
                  // subCovPackageList: [], //51292 - missing jaecoo limited speril
                  //subCoverList: [],
                  coverDto: {
                    //...updateQuotationDetails.riskList[0].coverList[0].coverDto,  //51292 - missing jaecoo limited speril
                    extCovPackageSelected: viewQuotationDetails.riskList[0].coverList[0].subCovPackage
                  }
                }
              ]
            }
          ]
        };
      this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: updateQuotationDetails, operator: this.userInfo.userId })).subscribe((statePremium) => {
        let latestCoveragePremium = statePremium?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
        this.recalculatePremium(latestCoveragePremium, updateQuotationDetails, false, false);
      });
    }else{
      this.router.navigate(['issuance/summary']);
    }
  }

  recalculatePremium(latestCoveragePremium, cngeNoteUpdated, isAutoRenewal, isRequote){
    if (latestCoveragePremium) {
      let previousSubCoverList = this.store.selectSnapshot<any>((state) => state.SatMotorState?.viewQuotation?.riskList?.[0].coverList?.[0].subCoverList);
      let hasWaiver = previousSubCoverList?.some(obj => (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') && obj.subCoverPrem > 0); 
      let hasSubCovPackageList = latestCoveragePremium?.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovPackageList;
      
      if (latestCoveragePremium.alimCustomerIndi || hasWaiver || (hasSubCovPackageList && hasSubCovPackageList.length > 0)) {
        let latestSubCovList = latestCoveragePremium?.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovList

        if (hasWaiver) {
          latestSubCovList = latestSubCovList?.map(obj => {
            if (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') {
              return { ...obj, selected: true }
            }
            return obj;
          })
        }

        cngeNoteUpdated = {
          ...cngeNoteUpdated,
          riskList: [{
            ...cngeNoteUpdated.riskList[0],
            coverList: [{
              ...cngeNoteUpdated.riskList[0].coverList[0],
              coverDto: {
                ...cngeNoteUpdated.riskList[0].coverList[0].coverDto|| {},
                subCovList: latestSubCovList || [],
                subCovPackageList: hasSubCovPackageList || []
              }
            }]
          }]
        };

      //for Alim customer without MRW & isWaiver
        this.store.dispatch(new CALCULATE_PREMIUM({ cngeNote: cngeNoteUpdated, operator: this.userInfo.userId })).subscribe((state) => {
          const latestCngeNote = state?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
          this.store.dispatch(new STORE_EXTRA_COVER_SUMMARY(latestCngeNote)); 
          this.router.navigate(['issuance/summary']);
        });
      } else {
        this.store.dispatch(new STORE_EXTRA_COVER_SUMMARY(latestCoveragePremium));
        this.router.navigate(['issuance/summary']);
      }

    }
  }

  isDisableQuotationPDF(): boolean {
    return this.validateAccess(AccessConfig.QUOTATION_PDF);
  }

  isDisableCoverNotePDF(): boolean {
    return this.validateAccess(AccessConfig.COVER_NOTE_PDF);
  }

  validateAccess(config: ButtonAccessConfig): boolean {
    return this.accessService.checkAccess(config);
  }

  getEQuotationECoverNoteLabel() {
    if(this.isCoverQuotation) {
      return "e-Quotation / e-Cover Note";
    }else if(this.isCoverNote) {
      return "e-Cover Note";
    }else {
      return "e-Quotation";
    }
  }

  getEQuotationECoverNoteNo() {
    if(this.isCoverQuotation) {
      return `${this.data.proposalNo} / ${this.data.cnoteNo}`;
    }else if(this.isCoverNote) {
      return this.data.cnoteNo;
    }else {
      return this.data.proposalNo;
    }
  }
}
